import React from "react";
import cn from "classnames";
import styles from "./Clients.module.sass";
import ScrollParallax from "../ScrollParallax";

const list = [
  {
    title: "hms",
    url: "/images/content/hms_logo.png"
  },
  {
    title: "oxford",
    url: "/images/content/oxford_logo.png"
  },
  {
    title: "ilab",
    url: "/images/content/hbs-logo.png"
  },
  {
    title: "bcg",
    url: "/images/content/bcg.png"
  },
  {
    title: "dvß",
    url: "/images/content/dv_logo.png"
  },
  
];

const TeamLogo = () => {
  return (
    <div className={styles.clients}>
      <div className={cn("container", styles.container)}>
        <ScrollParallax className={styles.title}>
        Our team studied and worked at world-class institutions and companies:
        </ScrollParallax>
        <div className={styles.list}>
          {list.map((x, index) => (
            <div className={styles.logo} key={index}>
              <img src={x.url} alt={x.title} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamLogo;
